import * as apiBff from './bff'

export async function getFamilies<T>(season: string, universeId: number, departmentId: number, subdepartmentId: number): Promise<T> {
  return apiBff.callBFF<T>(
    'GET',
    `season/${season}/universes/${universeId}/departments/${departmentId}/subdepartments/${subdepartmentId}`,
  )
}
